import type { District } from '../plot.ts'
import { decals, look, woodsy } from '../kit.ts'

/** Whisper Woods: where the river starts, a trail, a lookout and a clearing few people find. */
export const woods: District = {
  id: 'woods',
  name: 'Whisper Woods',
  ground: 'forest',
  ambience: ['leaves', 'fireflies'],
  build(p) {
    // The spring, and the river it feeds (it runs south through Sakura Hill and the canals).
    p.prop({ kind: 'pond', x: 13, y: 1, w: 9, d: 5 })
    p.zone(16, 6, 3, 26, 'canal')
    p.zone(0, 24, 36, 2, 'gravel'); p.zone(16, 24, 3, 2, 'bridge')
    p.zone(27, 3, 2, 21, 'gravel')
    // The lookout: rocks around a clearing at the top of the trail.
    p.zone(24, 0, 8, 4, 'dirt')
    p.prop({ kind: 'rock', x: 24, y: 1 }, { kind: 'rock', x: 31, y: 0 }, { kind: 'rock', x: 25, y: 3 }, { kind: 'bench', x: 29, y: 1, face: 1 })
    // The secret clearing west of the river.
    p.zone(3, 8, 9, 8, 'grass')
    p.zone(7, 16, 1, 8, 'dirt')
    p.prop(
      { kind: 'campfire', x: 7, y: 11 },
      { kind: 'stump', x: 6, y: 11, face: 1 }, { kind: 'stump', x: 8, y: 11, face: -1 }, { kind: 'stump', x: 7, y: 10, face: 1 }, { kind: 'stump', x: 7, y: 12, face: -1 },
      { kind: 'flowers', x: 4, y: 9, color: '#ffffff' }, { kind: 'flowers', x: 10, y: 9, color: '#b69cff' }, { kind: 'flowers', x: 4, y: 14, color: '#ff8fab' },
      { kind: 'signpost', x: 29, y: 26, text: 'Whisper Woods' },
    )
    p.tram(31, 27)
    p.place({ id: 'woods', name: 'Whisper Woods', blurb: 'A trail between tall pines, and the spring the river comes from.', x: 28, y: 22, accent: '#3f9d6a', r: 10 })
    p.place({ id: 'lookout', name: 'The Lookout', blurb: 'The top of the trail. You can see the whole town from here.', x: 28, y: 2, accent: '#a3b18a', r: 4 })
    p.place({ id: 'clearing', name: 'Secret Clearing', blurb: 'A fire someone keeps lit. Nobody admits to it.', x: 7, y: 14, accent: '#ffb36b', r: 4 })
    p.scatter({ density: 0.42, pick: woodsy([['pine', 5], ['tree', 4], ['bush', 1]]), on: ['forest'] })
    p.critter({ kind: 'butterfly', loop: [[4.5, 9.5], [10, 10], [9, 14.5], [5, 14]], speed: 0.5 })
    p.npc({
      id: 'npc-ranger', name: 'Ranger Pip', role: 'Explorer', look: look('pipkite', 8, 4, 4, 'propeller'), speed: 2.1,
      stops: [
        { x: 28, y: 5, wait: 6, emote: 'surprised', say: -1 },
        { x: 7, y: 14, wait: 8, emote: 'happy', say: -1 },
        { x: 33, y: 25, wait: 5 },
        { x: 17, y: 25, wait: 6, say: -1 },
      ],
      lines: ['Wheee!', 'The river starts right up there. Go see!', 'Shh, there is a clearing nobody knows about.', 'Race you to the lookout!'],
    })

    // ─── Detail ───
    p.scatter(decals(['leaves', 'leaves', 'moss'], 0.16, ['forest']))
    p.scatter({ density: 0.07, on: ['forest'], pick: (roll) => ({ kind: roll < 0.5 ? 'mushroom' : 'fern', x: 0, y: 0 }) })
    p.scatter({ density: 0.5, on: ['forest'], pick: (_r, x, y) => (p.at(x + 1, y) === 'canal' || p.at(x - 1, y) === 'canal' ? { kind: 'reeds', x: 0, y: 0 } : null) })
    p.prop({ kind: 'stump', x: 25, y: 2, face: 1 }, { kind: 'birdbath', x: 4, y: 10 }, { kind: 'aboard', x: 29, y: 23, text: 'Trail' })
    p.npc({
      id: 'npc-hiker', name: 'Hiker Hal', role: 'Hiker', look: look('hikerhal', 3, 4, 3, 'cap'), speed: 1.5,
      stops: [{ x: 33, y: 24, wait: 5 }, { x: 28, y: 3, wait: 20, emote: 'happy', say: -1 }, { x: 2, y: 25, wait: 8, say: -1 }],
      lines: ['What a view from the lookout!', 'Watch out for roots.', 'Bring snacks. Always bring snacks.'],
    })
  },
}
